import { render, staticRenderFns } from "./CompanyProductData.vue?vue&type=template&id=a00cb742&"
import script from "./CompanyProductData.vue?vue&type=script&lang=js&"
export * from "./CompanyProductData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports